import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import List from "./ListContainer";
import Pagination from "./PaginationContainer";
import Filter from "./FilterContainer";
import RangePicker from "./DateFilterContainer";
import { init } from "../../../redux/actions/visitActions";
import moment from "moment";
import IndicatorBanner from "../../../components/indicators/IndicatorBanner";
import { Link } from "react-router-dom";
import NextGenIndicators from "../../../components/nextgenindicators/NextGenIndicators";
import { ECOSYSTEM_ID, roles } from "../../../configs/constants";

class MainPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      listData_retailer_label: undefined,
      indicators: false
    };
  }
  fillListDataCards = label => {
    const { visits } = this.props;

    const labelsSet = [...new Set(visits.map(visit => visit[label]))]; //set of label

    const newListDataLabelsCards = labelsSet.map(name => {
      return {
        label: name,
        value: visits.reduce(
          (acc, cur) =>
            cur[label] === name && new Date(cur.startDate) >= new Date(`${new Date().getFullYear()}-01-01T00:00:00`)
              ? ++acc
              : acc,
          0
        )
      };
    });

    this.setState({ [`listData_${label}`]: newListDataLabelsCards });
    return newListDataLabelsCards;
  };

  componentDidMount() {
    this.props.init({});
  }

  render() {
    let listData_retailer_label = this.state.listData_retailer_label || [];
    if (!this.state.listData_retailer_label && this.props.visits.length > 0) {
      listData_retailer_label = this.fillListDataCards("retailer_label");
    }
    const { token, isNextGenIndicatorDisplayed } = this.props;
    const renderAllFilters =
      // this.props.currentSurveyId &&
      // (this.props.currentStartDate ||
      // 	(this.props.currentPeriod && this.props.currentPeriod.startDate)) &&
      // this.props.currentSurveyId.length > 0
      true ? (
        <Fragment>
          <div className="p-mrg-right" style={{ width: 150 }}>
            <Filter
              filterTargetKey={"sector_label"}
              placeholder={"Secteurs"}
              defaultValue={this.props.currentFilters["sector_label"]}
            />
          </div>
          <div className="p-mrg-right" style={{ width: 150 }}>
            <Filter
              filterTargetKey={"retailer_label"}
              placeholder={"Enseignes"}
              defaultValue={this.props.currentFilters["retailer_label"]}
            />
          </div>
          <div className="p-mrg-right" style={{ width: 150 }}>
            <Filter
              filterTargetKey={"salepoint.city"}
              placeholder={"Villes"}
              defaultValue={this.props.currentFilters["salepoint.city"]}
            />
          </div>
          <div className="p-mrg-right" style={{ width: 150 }}>
            <Filter
              filterTargetKey={"pdc_label"}
              placeholder={"PDC"}
              depKey={"retailers"}
              defaultValue={this.props.currentFilters["pdc_label"]}
            />
          </div>
        </Fragment>
      ) : null;
    let fullWidth = !this.state.indicators ? "p-content-page-center-full" : "";
    let indicatorBtn = !this.state.indicators ? "p-btn-blue" : "p-btn-blue";

    return (
      <Fragment>
        <div className={`p-content-page-center ${fullWidth}`}>
          <div className="p-content-page-center-header">
            <h2 className="p-content-page-center-header-title">Liste des visites effectuées </h2>
            <div>{isNextGenIndicatorDisplayed && <NextGenIndicators token={token} />}</div>
            <div className="p-content-page-center-header-buttons"></div>
          </div>
          <div className="p-content-page-center-filters">
            <div className="p-mrg-right p-mrg-bot" style={{ width: 150 }}>
              <Filter
                filterTargetKey={"user_email"}
                placeholder={"Utilisateurs"}
                defaultValue={this.props.currentFilters["user_email"]}
              />
            </div>
            <div className="p-mrg-right p-mrg-bot" style={{ width: 230 }}>
              <RangePicker
                filterTargetKey={"period"}
                defaultRange={[moment().startOf("year"), moment().endOf("day")]}
              />
            </div>
            <div className="p-mrg-right p-mrg-bot" style={{ width: 150 }}>
              <Filter
                filterTargetKey={"surveyId"}
                filterIdKey={"surveyId"}
                filterLabelKey={"surveyId"}
                placeholder={"Missions"}
                defaultValue={this.props.currentFilters["surveyId"]}
              />
            </div>
            {renderAllFilters}
          </div>
          <div>Nombre de visites : {this.props.nbVisits}</div>
          <div className="p-content-page-center-content">
            <List
              columns={[
                {
                  title: "Utilisateur",
                  key: "user_fullName",
                  sortable: true
                },
                {
                  title: "Secteur",
                  key: "sector_label",
                  sortable: true
                },
                /*{
                    title: "Enseigne",
                    key: "retailer_label",
                    sortable: true
                  },*/
                {
                  title: "PDC",
                  key: "pdc_label",
                  sortable: true
                },
                {
                  title: "Ville",
                  key: "salepoint.city",
                  sortable: true
                },
                {
                  title: "PDC ID",
                  key: "pdc_id",
                  sortable: true
                },
                /*{
                    title: "Nom",
                    key: "title",
                    sortable: true
                  },*/
                {
                  title: "Date",
                  key: "Day",
                  sortable: true,
                  render: (text, record, index) => {
                    return <div>{moment(record.startDate).format("DD/MM/YY")}</div>;
                  }
                },
                {
                  title: "Durée",
                  key: "duration",
                  render: (text, record, index) => {
                    record = record || {};
                    return (
                      <div>{moment.utc(moment(record.endDate).diff(moment(record.startDate))).format("HH:mm:ss")}</div>
                    );
                  }
                },
                {
                  title: "Début",
                  key: "startDate",
                  sortable: true,
                  render: (text, record, index) => {
                    return <div>{moment(text).format("HH:mm:ss")}</div>;
                  }
                },
                {
                  title: "Fin",
                  key: "endDate",
                  sortable: true,
                  render: (text, record, index) => {
                    return <div>{moment(text).format("HH:mm:ss")}</div>;
                  }
                },
                {
                  title: "Actions",
                  key: "actions",
                  sortable: false,
                  render: (text, record, index) => {
                    return (
                      <div style={{ height: 36, paddingTop: 11 }}>
                        <Link
                          to={{
                            pathname: `/visit/preview/${record._id}`
                          }}
                        >
                          Voir
                        </Link>
                        {this.props.currentRoleId === 1 ? <div>{record.version}</div> : null}
                      </div>
                    );
                  }
                }
              ]}
            />
            <div className="p-al-right p-mrg-ver p-mrg-bot-l">
              <Pagination />
            </div>
          </div>
        </div>
        {this.state.indicators ? (
          <div className="p-content-page-right">
            <h3 className="p-content-page-right-title">Enseignes visitées</h3>
            <IndicatorBanner size="small" items={listData_retailer_label} />
          </div>
        ) : null}
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const currentClient = state.currentClient || {};
  const isNextGenClient = currentClient.id === ECOSYSTEM_ID;
  const currentUser = state.userInfos || {};
  const currentRoleId = currentUser.role_id || 100;
  const isNextGenIndicatorDisplayed = isNextGenClient && currentRoleId <= roles.ADMIN;
  return {
    visits: state.visit.visits || [],
    currentPage: state.visit.currentPage, // a supprimer ?
    hasNext: state.visit.hasNext, // à supprimer ?
    nbVisits: state.visit.total,
    currentSurveyId: state.visit.currentFilters.surveyId,
    currentStartDate: state.visit.currentFilters.startDate,
    currentPeriod: state.visit.currentFilters.period,
    currentFilters: state.visit.currentFilters,
    token: state.auth.token,
    currentRoleId,
    isNextGenIndicatorDisplayed
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    init: () => {
      dispatch(init());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainPage);



// WEBPACK FOOTER //
// src/containers/activite/visit/MainContainer.js